import { nafColor } from '@nafcore/theme';
import { colors } from '@naf-simba/theme';
import { YoutubeShortsBackgroundType } from '../../../../types/YoutubeShortsBlockType';
import { ShortVideo } from './ShortsCarousel';

export const CARD_WIDTH = 250;
export const CARD_GAP = 40;

const SHORTS_EMBED_PARAMETERS = 'playsinline=1&iv_load_policy=3&modestbranding=1&controls=1&rel=0';

export const getBackgroundColor = (background: YoutubeShortsBackgroundType): string => {
  switch (background) {
    case 'dew':
      return colors.secondary[50];
    case 'none':
      return nafColor.signature.white;
    case 'primary':
    default:
      return nafColor.signature.yellow20;
  }
};

export const getEmbedUrl = (video: ShortVideo): string =>
  `https://www.youtube.com/embed/${video.id}?${SHORTS_EMBED_PARAMETERS}`;
